var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"left-sidebar d-lg-flex pl-2 sticky-column col-xl-2"},[_c('div',{staticClass:"SideBarItems"},_vm._l((_vm.items.squareItems),function(item,index){return _c('LeftSideBarItemSquare',{key:index,attrs:{"icon":item.itemIcon,"title":item.itemText}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }